import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Skeleton } from '../components/ui/skeleton';

// Import persona-specific dashboards
import AthleteDashboard from '../components/dashboards/AthleteDashboard';
import CoachDashboard from '../components/dashboards/CoachDashboard';
import ClubDashboard from '../components/dashboards/ClubDashboard';
import PhysioDashboard from '../components/dashboards/PhysioDashboard';
import NutritionistDashboard from '../components/dashboards/NutritionistDashboard';
import FanDashboard from '../components/dashboards/FanDashboard';

const Dashboard = () => {
  const [persona, setPersona] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!user || !user.persona) {
      navigate('/login');
      return;
    }
    setPersona(user.persona);
  }, [navigate]);

  const renderDashboard = () => {
    switch (persona) {
      case 'athlete':
        return <AthleteDashboard />;
      case 'coach':
        return <CoachDashboard />;
      case 'club':
        return <ClubDashboard />;
      case 'physio':
        return <PhysioDashboard />;
      case 'nutritionist':
        return <NutritionistDashboard />;
      case 'fan':
        return <FanDashboard />;
      default:
        return <div className="text-center py-12">Unknown persona type</div>;
    }
  };

  if (!persona) {
    return (
      <div className="min-h-screen bg-background pb-20 md:pb-0">
        <Navbar />
        <div className="max-w-7xl mx-auto px-4 pt-20" data-testid="dashboard-skeleton">
          {/* Stats row skeleton */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="rounded-2xl bg-card p-5 shadow-sm">
                <div className="flex items-center justify-between mb-3">
                  <Skeleton className="h-3.5 w-20" />
                  <Skeleton className="w-9 h-9 rounded-lg" />
                </div>
                <Skeleton className="h-7 w-12 mb-1" />
                <Skeleton className="h-3 w-16" />
              </div>
            ))}
          </div>
          {/* Content area skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
            <div className="md:col-span-2 space-y-4">
              <Skeleton className="h-10 w-48" />
              {[0, 1, 2].map((i) => (
                <div key={i} className="rounded-2xl bg-card p-5 shadow-sm space-y-3">
                  <div className="flex items-center gap-3">
                    <Skeleton className="w-10 h-10 rounded-full" />
                    <div className="space-y-1.5 flex-1">
                      <Skeleton className="h-3.5 w-28" />
                      <Skeleton className="h-3 w-20" />
                    </div>
                  </div>
                  <Skeleton className="h-3.5 w-full" />
                  <Skeleton className="h-3.5 w-2/3" />
                </div>
              ))}
            </div>
            <div className="space-y-4">
              <div className="rounded-2xl bg-card p-5 shadow-sm space-y-3">
                <Skeleton className="h-5 w-32" />
                {[0, 1, 2].map((i) => (
                  <div key={i} className="flex items-center gap-3">
                    <Skeleton className="w-10 h-10 rounded-full" />
                    <div className="space-y-1.5 flex-1">
                      <Skeleton className="h-3.5 w-24" />
                      <Skeleton className="h-3 w-16" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background pb-20 md:pb-0">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 pt-20">
        {renderDashboard()}
      </div>
    </div>
  );
};

export default Dashboard;
